import { Component, Input } from '@angular/core';
import { SessionService } from '@monsido/core/session/session.service';
import { LoginService } from '@client/app/core/services/login/login.service';
import { proxyApiPath } from '@monsido/core/constants/general.constant';

@Component({
    selector: 'sop-button',
    standalone: false,
    template: `
        <a *ngIf="canSeeClassicShowOnPage() && canAccessDomain()"
           [href]="getUrl()"
           target="_blank"
           aria-describedby="linkOpensInNewTab"
           class="btn btn-border-radius btn-secondary"
           translate>Visual mode</a>
    `,
})
export class SopButtonComponent {
    @Input() page: any;

    constructor (
        private sessionService: SessionService,
        private loginService: LoginService,
    ) {}

    canAccessDomain (): boolean {
        return !!this.sessionService.domain;
    }

    canSeeClassicShowOnPage (): boolean {
        return this.sessionService.customer && (this.sessionService.customer.plan_traits as any).classic_show_on_page;
    }

    canAccessPage (): boolean {
        return this.page && this.page.id > 0;
    }

    getUrl (): string | undefined {
        if (!this.canAccessDomain() || !this.canAccessPage()) {
            return;
        }

        let basePath = proxyApiPath;
        // An HTTP iframe can't be loaded on a HTTPS, so we need to load the Acquia Web Governance Show On Page over HTTP
        if (this.page.url.match(/^http:/)) {
            basePath = basePath.replace('https://', 'http://');
        }

        return (
            basePath +
            '/domains/' +
            this.sessionService.getDomainId() +
            '/pages/' +
            this.page.id +
            '/show_on_page?customer_id=' +
            this.sessionService.getCustomerId()
        );
    }
}
